import { render, staticRenderFns } from "./HomepageManagement.vue?vue&type=template&id=0a21548c&scoped=true"
import script from "./HomepageManagement.vue?vue&type=script&lang=js"
export * from "./HomepageManagement.vue?vue&type=script&lang=js"
import style0 from "./HomepageManagement.vue?vue&type=style&index=0&id=0a21548c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21548c",
  null
  
)

export default component.exports